module.exports = "/images/vendor/tui-image-editor/dist/svg/icon-a.svg?843c03ed6edd3f2a4dc35357feedbbec";